// extracted by mini-css-extract-plugin
export default {"addBeneficiaryButton":"AddBeneficiaryButton_addBeneficiaryButton__oW2Oe"};